import { startRequest, stopRequest, setSnackbar } from "redux/actions/search/searchActions";
import { addDetails } from "./addDetails";
import { api_get } from "services/api";

export const graphRequest = async (stationName, dispatch) => {
  const url = `${process.env.REACT_APP_URL}/crm/aws/graphs/${stationName}`;
  dispatch(startRequest())
  const data = await api_get(url).then(resp => addDetails(resp))
    .catch(err => {
      dispatch(setSnackbar(err ? err : "Error contacte al administrador"))
      return null
    })
  dispatch(stopRequest())
  return data
}

export const graphRequest24hrs = async (idStation, device, unitType, dispatch, tank = '') => {
  const url = `${process.env.REACT_APP_URL}/crm/aws/graphs/24hrs/${device}?station=${idStation}&unitType=${unitType}${tank ? `&tank=${tank}` : ''}`;
  dispatch(startRequest())
  const data = await api_get(url).then(resp => resp)
    .catch(err => {
      dispatch(setSnackbar(err ? err : "Error contacte al administrador"))
      return []
    })
  dispatch(stopRequest())
    return data
  
}